import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

// import InternationalsCreateContent from '../../../components/Pages/Internationals/Create';
import PageCreateContent from '../../../components/Pages/Pages/Create';

export default function PageCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Create page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <PageCreateContent />
    </Layout>
  );
}
